export default __webpack_public_path__ + "static/media/icon-12.bd90034b.png";